import { render, staticRenderFns } from "./WarenkorbLieferung.vue?vue&type=template&id=71053583"
import script from "./WarenkorbLieferung.vue?vue&type=script&lang=ts"
export * from "./WarenkorbLieferung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports